import { StyleSheet } from 'react-native'
import theme from '../../../theme'
import { colorButtonTextEnabled, colorText, ProfileDividerTheme } from '../../../themeConstants'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#FFFFFF',
        padding: 0,
    },
    deleteBlock: {
        marginTop: 10,
        marginBottom: 12,
        alignItems: 'center',
    },
    deleteText: {
        fontSize: 15,
        color: theme.colors.error,
        fontWeight: 'bold',
    },
    containerRow: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    scrollView: {
        flex: 1,
        justifyContent: 'space-between',
    },
    logoutBlock: {
        marginTop: 20,
        alignItems: 'center',
    },
    logoutText: {
        fontSize: 16,
        color: theme.colors.error,
        fontWeight: 'bold',
    },
    mainButton: {
        marginTop: 10,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
    },
    mainButtonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    borderButton: {
        marginTop: 10,
        backgroundColor: 'white',
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        padding: 8,
        borderRadius: 10,
    },
    borderButtonText: {
        fontSize: 16,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    borderRedButton: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 10,
        backgroundColor: 'white',
        borderWidth: 2,
        borderColor: theme.colors.error,
        padding: 8,
        borderRadius: 10,
    },
    version: {
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingBottom: 12,
    },
    iconButton: {
        marginLeft: 5,
    },
    containerTextIcon: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    textButton: {
        fontSize: 14,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
    },
    borderRedButtonText: {
        fontSize: 16,
        color: theme.colors.error,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    containerModal: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 12,
    },
    spacer: {
        height: 45,
    },
    spacer1: {
        height: 8,
    },
    spacer2: {
        height: 20,
    },
    spacer3: {
        height: 12,
    },
    inputLocked: {
        flex: 1,
        height: 40,
        marginTop: 5,
        marginBottom: 15,
        borderColor: theme.colors.darkGray,
        backgroundColor: theme.colors.lightGray,
        color: theme.colors.textPrimary,
        padding: 10,
        borderWidth: 0.5,
        borderRadius: 5,
    },
    tagInput: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
    },
    inputRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    data: {
        fontSize: 15,
        fontWeight: 'normal',
    },
    editIcon: {
        justifyContent: 'center',
    },
    modalOverlay: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fondo semi-transparente
    },
    modalSubtitle: {
        fontSize: 16,
        fontWeight: 'normal',
        marginBottom: 15,
        color: theme.colors.textSecondary,
    },
    modalContainer: {
        width: '80%',
        backgroundColor: 'white',
        borderRadius: 10,
        paddingHorizontal: 12,
        paddingVertical: 20,
        alignItems: 'center',
        elevation: 5, // Sombra para Android
        shadowColor: 'black', // Sombra para iOS
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.2,
        shadowRadius: 4,
    },
    input_verification: {
        width: '100%',
        height: 40,
        borderColor: theme.colors.lightGray,
        borderWidth: 0.5,
        borderRadius: 5,
        paddingHorizontal: 12,
        marginBottom: 12,
    },
    modalTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 4,
        color: theme.colors.textPrimary,
    },
    input: {
        flex: 1,
        height: 40,
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        paddingVertical: 10,
        paddingHorizontal: 10,
        marginTop: 4,
        marginBottom: 15,
        alignItems: 'center',
        color: theme.colors.textPrimary,
    },
    inputBlock: {
        flexDirection: 'row',
        width: '100%',
        height: 40,
        borderWidth: 1,
        borderRadius: 10,
        borderColor: theme.colors.lightGray,
        backgroundColor: 'white',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 20,
        marginTop: 0,
    },
    dropdown: {
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        color: theme.colors.textPrimary,
        marginTop: -2,
        marginBottom: 15,
    },
    dropdownOptions: {
        color: theme.colors.textPrimary,
    },
    dropdownInput: {
        color: theme.colors.textPrimary,
    },
    messageContainer: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        padding: 10,
        marginBottom: 10,
        borderRadius: 5,
    },
    image: {
        width: 120,
        height: 120,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 24,
    },
    description: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 20,
        paddingHorizontal: 12,
    },
    buttonContainer: {
        flexDirection: 'column',
        width: '100%',
        paddingVertical: 5,
    },
    containerVerified: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.formsBackground,
        borderRadius: 8,
        marginTop: 10,
    },
    containerToVerify: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
        borderColor: theme.colors.colorPrimary,
        borderWidth: 2.0,
        borderRadius: 8,
        marginTop: 10,
    },
    textVerified: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.colorApproved,
        paddingVertical: 0,
    },
    textToVerify: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        paddingVertical: 8,
    },
    shadow: {
        width: '100%',
        height: 6,
        opacity: 0.2,
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
    },
    divider: {
        flex: 1,
        borderWidth: 0.5,
        borderColor: ProfileDividerTheme.color,
        backgroundColor: ProfileDividerTheme.color,
    },
    marginLeft: {
        marginLeft: 8,
    },
    marginHorizontal: {
        marginHorizontal: 12,
    },
    paddingHorizontal: {
        paddingHorizontal: 12,
    },
    marginBottom: {
        marginBottom: 10,
    },
})

export default styles
